// AUTOGENERATED
import * as Data$dIdentity from "../Data.Identity/index.js";
import * as Data$dList$dTypes from "../Data.List.Types/index.js";
import * as Data$dShow from "../Data.Show/index.js";
import * as Data$dShow$dGeneric from "../Data.Show.Generic/index.js";
import * as Foreign from "../Foreign/index.js";
import * as Foreign$dEncoding from "../Foreign.Encoding/index.js";
import * as Foreign$dGeneric$dClass from "../Foreign.Generic.Class/index.js";
import * as Type$dProxy from "../Type.Proxy/index.js";
import * as Unsafe$dCoerce from "../Unsafe.Coerce/index.js";
import * as Unscramble from "../Unscramble/index.js";
const StreetAddress = x => x;
const newtypeStreetAddress_ = {Coercible0: () => {}};
const hasFieldStreetAddress = dictHasField => dictHasField;
const eqStreetAddress = {eq: x => y => x.city === y.city && x.street === y.street && x.streetNumber === y.streetNumber};
const genericStreetAddress = {to: x => x, from: x => x};
const showStreetAddress = {
  show: /* #__PURE__ */ (() => {
    const $0 = Data$dShow$dGeneric.genericShowConstructor({
      genericShowArgs: v => [
        (() => {
          const v$1 = Data$dShow.cons(Data$dShow.intercalate(": ")(["city", Data$dShow.showStringImpl(v.city)]))(Data$dShow.cons(Data$dShow.intercalate(": ")([
            "street",
            Data$dShow.showStringImpl(v.street)
          ]))(Data$dShow.cons(Data$dShow.intercalate(": ")(["streetNumber", Data$dShow.showStringImpl(v.streetNumber)]))([])));
          if (v$1.length === 0) { return "{}"; }
          return Data$dShow.intercalate(" ")(["{", Data$dShow.intercalate(", ")(v$1), "}"]);
        })()
      ]
    })({reflectSymbol: () => "StreetAddress"});
    return x => $0["genericShow'"](x);
  })()
};
const unscrambleDecodeStreetAddress = /* #__PURE__ */ (() => (
  {
    unsafeDecode: Unscramble.decodeRecord(Unscramble.decodeRecordCons({reflectSymbol: () => "city"})(Unscramble.decodeString1)(Unscramble.decodeRecordCons({
      reflectSymbol: () => "street"
    })(Unscramble.decodeString1)(Unscramble.decodeRecordCons({reflectSymbol: () => "streetNumber"})(Unscramble.decodeString1)(Unscramble.decodeRecordNil))).recordInfo(Type$dProxy.Proxy))
  }
))();
const encodeStreetAddress = {
  encode: /* #__PURE__ */ Foreign$dEncoding.defaultEncode(genericStreetAddress)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericEncodeConstructor({
    reflectSymbol: () => "StreetAddress"
  })(/* #__PURE__ */ (() => {
    const $0 = Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)({
      reflectSymbol: () => "streetNumber"
    })({encodeWithOptions: v => Unsafe$dCoerce.unsafeCoerce}))({reflectSymbol: () => "street"})({encodeWithOptions: v => Unsafe$dCoerce.unsafeCoerce}))({
      reflectSymbol: () => "city"
    })({encodeWithOptions: v => Unsafe$dCoerce.unsafeCoerce});
    return {
      encodeArgs: opts => v => Data$dList$dTypes.$List(
        "Cons",
        Foreign$dGeneric$dClass.$Arg("RecArg", $0.encodeRecordWithOptions(Type$dProxy.Proxy)(opts)(v)),
        Data$dList$dTypes.Nil
      )
    };
  })()))
};
const decodeStreetAddress = {
  decode: /* #__PURE__ */ Foreign$dEncoding.defaultDecode(genericStreetAddress)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor({
    reflectSymbol: () => "StreetAddress"
  })(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeArgsRecord(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordNil)({
    reflectSymbol: () => "streetNumber"
  })({decodeWithOptions: v => Foreign.readString(Data$dIdentity.monadIdentity)})())({reflectSymbol: () => "street"})({
    decodeWithOptions: v => Foreign.readString(Data$dIdentity.monadIdentity)
  })())({reflectSymbol: () => "city"})({decodeWithOptions: v => Foreign.readString(Data$dIdentity.monadIdentity)})())))(Foreign$dGeneric$dClass.genericCountArgsArgument))
};
export {
  StreetAddress,
  decodeStreetAddress,
  encodeStreetAddress,
  eqStreetAddress,
  genericStreetAddress,
  hasFieldStreetAddress,
  newtypeStreetAddress_,
  showStreetAddress,
  unscrambleDecodeStreetAddress
};
